import React, { forwardRef } from 'react';
import clsx from 'clsx';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, label, ...props },
  ref
) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
      <input
        ref={ref}
        type="checkbox"
        className={clsx(className)}
        style={{ accentColor: 'var(--brand)' }}
        {...props}
      />
      {label && <span>{label}</span>}
    </label>
  );
});

export default Checkbox; 